import ActivityList from '@gaia/components/ActivityList';
import Button from '@gaia/components/Button';
import theme from '@gaia/theme';
import {Typography} from '@mui/material';

interface ActivitySelectionProps {
    setStepCount: SetState<number>;
    setSelectedActivities: SetState<string[]>;
    selectedActivities: string[];
}

export default function ActivitySelection({
    setStepCount,
    setSelectedActivities,
    selectedActivities,
}: ActivitySelectionProps) {
    return (
        <div>
            <Typography variant='h5' style={{marginTop: theme.spacing(2)}}>
                How do you explore the outdoors?
            </Typography>
            <Typography variant='body1' style={{margin: theme.spacing(1)}}>
                Pick your top activities.
            </Typography>
            <ActivityList
                allowMultiSelections
                selectedActivities={selectedActivities}
                setSelectedActivities={setSelectedActivities}
            />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    appearance='secondary'
                    onClick={() => setStepCount((prevState: number) => prevState - 1)}
                >
                    Back
                </Button>
                <Button
                    appearance='primary'
                    onClick={() => setStepCount((prevState: number) => prevState + 1)}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
